module.exports = __webpack_public_path__ + "media/images/IG_Glyph_Fill-aa26f9f0c4689836830c6a92563c3ec5.png";